import { FormikHelpers } from "formik";
import { useCreatePhoneLine } from "./api/createPhoneLine";
import BulkDeletePhoneLinesForm from "./BulkDeletePhoneLinesForm";
import { useΒulkDeletePhoneLines } from "./api/bulkDeletePhoneLines";


const BulkDeletePhoneLines = ({handleCloseModal}: CreatePhoneLineProps)  => {
  const bulkDeletePhoneLinesMutation = useΒulkDeletePhoneLines({data: {}});

  const initialValues: IBulkDeletePhoneLines = {
    callNumberFrom: "",
    callNumberTo: "",
    countOfCallNumbersToDelete: "",
    deletionDate: null,
    deletionComments: ""
  };

  const handleSubmit = async (values: IBulkDeletePhoneLines, { setSubmitting }: FormikHelpers<IBulkDeletePhoneLines>): Promise<void> => {
    bulkDeletePhoneLinesMutation.mutateAsync({
      data: values
    })

    setSubmitting(false);
    handleCloseModal();
  }

  return (
    <BulkDeletePhoneLinesForm initialValues={initialValues} onSubmit={handleSubmit} />
  )
}

interface CreatePhoneLineProps {
  handleCloseModal: () => void;
}

export default BulkDeletePhoneLines;